module.exports = __webpack_public_path__ + "static/media/white_logo.35ad5070.svg";